import { Languages, Check } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { LANGS, useI18n } from "@/i18n/context";

export default function LanguageSwitcher({ testid = "lang-switcher" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    if (open) window.addEventListener("mousedown", close);
    return () => window.removeEventListener("mousedown", close);
  }, [open]);

  const active = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref} data-testid={testid}>
      <button
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm text-zinc-300 hover:bg-white/[0.08]"
        aria-label="Sprache wählen"
        data-testid={`${testid}-toggle`}
      >
        <Languages size={15} /> <span className="font-mono-accent tabular-nums text-xs">{active.short}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 rounded-xl card-soft py-2 z-40" data-testid={`${testid}-menu`}>
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-4 py-2 text-sm hover:bg-white/[0.06] ${lang === l.code ? "text-[#0055FF]" : "text-zinc-200"}`}
              data-testid={`${testid}-${l.code}`}
            >
              <span>{l.label}</span>
              {lang === l.code && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
